(function () {
    'use strict';

    angular
        .module('app.scoring')
        .component('sc3Scoring', {
            templateUrl: 'app/scoring/scoring.component.html',
            controller: ScoringComponent,
            bindings: {
                profile: '<'
            }
        });

    var noop = angular.noop;

    ScoringComponent.$inject = ['$state', 'user', 'memberLookupModal', 'clubMembershipLevelType'];
    function ScoringComponent($state, user, memberLookupModal, clubMembershipLevelType) {
        var ctrl = this;
        Object.defineProperty(ctrl, 'isCurrentUser', { get: getIsCurrentUser });
        Object.defineProperty(ctrl, 'isBronze', { get: getIsBronze });

        ctrl.$onInit = init;
        ctrl.change = change;

        //////////////////////////////////////////

        function init() {
            if (!ctrl.profile.individualId)
                change();
        }

        function change() {
            memberLookupModal().result.then(change, noop);

            function change(member) {
                $state.go('scoring', { individualId: member.individualId });
            }
        }

        function getIsCurrentUser() {
            return user.id && user.id === ctrl.profile.individualId;
        }
        function getIsBronze() {
            return user.membershipLevel === clubMembershipLevelType.Bronze;
        }
    }
})();